'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTableProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _declineObservationsOverAttributes = require('./declineObservationsOverAttributes');

var _getLayout = require('./getLayout');

var _getSortedLayoutIndexes = require('./getSortedLayoutIndexes');

var _parseSeriesIndexesHierarchies = require('./parseSeriesIndexesHierarchies');

var _refineLayoutSize = require('./refineLayoutSize2');

var _getLayoutData = require('./getLayoutData2');

var _getCellsAttributesIds = require('./getCellsAttributesIds');

var _getIndexedCombinationsByDisplay = require('./getIndexedCombinationsByDisplay');

var _getCells = require('./getCells');

var _getCuratedCells = require('./getCuratedCells');

var _getSeriesCombinations = require('../getSeriesCombinations');

var _getCellsMetadataCoordinates = require('./getCellsMetadataCoordinates');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTableProps = exports.getTableProps = function getTableProps(_ref) {
  var data = _ref.data,
      layoutIds = _ref.layoutIds,
      customAttributes = _ref.customAttributes,
      limit = _ref.limit,
      isTimeInverted = _ref.isTimeInverted;
  var observations = data.observations,
      dimensions = data.dimensions,
      combinations = data.combinations,
      oneValueDimensions = data.oneValueDimensions,
      attributesSeries = data.attributesSeries,
      metadataCoordinates = data.metadataCoordinates,
      attributes = data.attributes,
      header = data.header;


  var obsAttributes = R.filter(function (a) {
    return a.series && R.isEmpty(a.relationship) && a.display && !a.combined;
  }, attributes);
  var dupObs = observations;
  var hasDuplicatedCells = R.pipe(R.values, R.unnest, R.find(R.equals('OBS_ATTRIBUTES')))(layoutIds);
  if (hasDuplicatedCells) {
    var attrsIds = R.pluck('id', obsAttributes);
    dupObs = (0, _declineObservationsOverAttributes.declineObservationsOverAttributes)(attrsIds, observations);
  }
  var seriesCombinations = (0, _getSeriesCombinations.getSeriesCombinations)(combinations, oneValueDimensions);
  var _dims = R.append({
    id: 'OBS_ATTRIBUTES',
    values: R.prepend({ id: 'OBS_VALUE' }, obsAttributes)
  }, dimensions);
  var layout = (0, _getLayout.getLayout)(layoutIds, _dims, seriesCombinations, isTimeInverted);
  var layoutDimsIds = R.map(R.reduce(function (acc, entry) {
    if (R.has('dimensions', entry)) {
      return R.concat(acc, R.pluck('id', entry.dimensions));
    }
    return R.append(entry.id, acc);
  }, []), layout);
  var layoutIndexes = (0, _getSortedLayoutIndexes.getSortedLayoutIndexes)(layout, dupObs);
  var enhancedLayoutIndexes = (0, _parseSeriesIndexesHierarchies.parseLayoutIndexesHierarchies)(layoutIndexes, layout);
  var refinedLayoutIndexes = (0, _refineLayoutSize.refineLayoutSize)({ layout: layout, observations: dupObs, limit: limit })(enhancedLayoutIndexes);
  var layoutData = (0, _getLayoutData.getLayoutData)(refinedLayoutIndexes, layout, { metadataCoordinates: metadataCoordinates, attributesSeries: attributesSeries, customAttributes: customAttributes, topCoordinates: header.coordinates });

  var cellsAttributesIds = (0, _getCellsAttributesIds.getCellsAttributesIds)(layoutDimsIds, attributes);
  var indexedCombinations = (0, _getIndexedCombinationsByDisplay.getIndexedCombinationsByDisplay)(layout, seriesCombinations);
  var cellsMetadataCoordinates = (0, _getCellsMetadataCoordinates.getCellsMetadataCoordinates)(metadataCoordinates, oneValueDimensions, layoutDimsIds);
  var cells = (0, _getCells.getCells)(customAttributes, cellsAttributesIds, indexedCombinations, attributesSeries, cellsMetadataCoordinates)(dupObs);

  return (0, _extends3.default)({}, layoutData, {
    cells: (0, _getCuratedCells.getCuratedCells)(cells, layout),
    layout: layout,
    combinations: seriesCombinations
  });
};